import { useCallback, useEffect, useState } from "react";
import { apiService } from "../api/services/apiService";
import type { KafkaEventTopic } from "../types";

export function useKafkaEventTopics() {
  const [topics, setTopics] = useState<KafkaEventTopic[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const list = await apiService.getKafkaEventTopics();
      setTopics(list);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : "Failed to load Kafka event topics");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { topics, loading, error, refresh };
}
